import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-780b8e98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Quel film cherchez-vous ?", -1))
const _hoisted_3 = { class: "d-flex flex-column mx-auto align-items-center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Aucun film trouvé", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "table table-dark" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Titre ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://img.icons8.com/material-outlined/24/000000/generic-sorting.png" }, null, -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Année ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://img.icons8.com/material-outlined/24/000000/generic-sorting.png" }, null, -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Réalisateur ")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://img.icons8.com/material-outlined/24/000000/generic-sorting.png" }, null, -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Affiche ")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://img.icons8.com/material-outlined/24/000000/generic-sorting.png" }, null, -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "col-1"
}, "Modifier", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "col-1"
}, "Supprimer", -1))
const _hoisted_22 = {
  align: "center",
  scope: "row"
}
const _hoisted_23 = ["src"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary" }, "Modifier", -1))
const _hoisted_25 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
        class: "col-4",
        type: "search",
        placeHolder: "rechercher par titre de film"
      }, null, 512), [
        [_vModelText, _ctx.search]
      ]),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.getResult && _ctx.getResult(...args))),
        class: "col-1 my-3 btn-primary btn"
      }, " Rechercher ")
    ]),
    ((_ctx.filteredMovie.length === 0))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : _createCommentVNode("", true),
    _createElementVNode("table", _hoisted_7, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", {
            scope: "col",
            class: "col-3",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sortTable('title')))
          }, _hoisted_10),
          _createElementVNode("th", {
            class: "col-1",
            scope: "col",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sortTable('year')))
          }, _hoisted_13),
          _createElementVNode("th", {
            scope: "col",
            class: "col-3",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sortTable('director')))
          }, _hoisted_16),
          _createElementVNode("th", {
            scope: "col",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sortTable('posterUrl')))
          }, _hoisted_19),
          _hoisted_20,
          _hoisted_21
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredMovie, (movie) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: movie.id
          }, [
            _createElementVNode("td", _hoisted_22, _toDisplayString(movie.title), 1),
            _createElementVNode("td", null, _toDisplayString(movie.year), 1),
            _createElementVNode("td", null, _toDisplayString(movie.director), 1),
            _createElementVNode("td", null, [
              _createElementVNode("img", {
                class: "img-thumbnail img-movies",
                src: movie.posterUrl,
                alt: "affiche du film"
              }, null, 8, _hoisted_23)
            ]),
            _createElementVNode("td", null, [
              _createVNode(_component_router_link, {
                to: { name: 'update', params: { id: movie.id } }
              }, {
                default: _withCtx(() => [
                  _hoisted_24
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.deleteMovie(movie.id)),
                class: "btn btn-danger"
              }, " Supprimer ", 8, _hoisted_25)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}